/** Barra de consumo de presupuesto con semáforo (>100% rosa, ≥80% ámbar). */

export function barColor(pct: number): string {
  if (pct > 100) return "bg-rose-500";
  if (pct >= 80) return "bg-amber-500";
  return "bg-emerald-500";
}

export function ConsumptionBar({
  label, amount, spent, pct, currency,
}: { label: string; amount: number | null; spent: number; pct: number | null; currency: string }) {
  const money = (v: number) => `${currency} ${v.toLocaleString("es-PE", { minimumFractionDigits: 2 })}`;
  const shownPct = pct ?? 0;
  return (
    <div>
      <div className="flex items-center justify-between text-xs mb-1">
        <span className="text-ink-700 dark:text-ink-200 truncate">{label}</span>
        <span className="text-ink-500 shrink-0 ml-2">
          {money(spent)}{amount != null && <> / {money(amount)}</>}
          {pct != null && <span className="ml-1 font-semibold">({pct}%)</span>}
        </span>
      </div>
      <div className="h-2 rounded-full bg-ink-100 dark:bg-ink-800 overflow-hidden">
        <div className={`h-full ${barColor(shownPct)} transition-all`}
          style={{ width: `${Math.min(shownPct, 100)}%` }} />
      </div>
    </div>
  );
}
